module.exports = __webpack_public_path__ + "static/media/img3-1.a760319b.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/fresa/soilcheck/mo/img3-1.png
// module id = 1618
// module chunks = 3